import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { api } from '../URL/api-url';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiCommonService } from '../services/api-common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  downloadCollapse = false
  sidebarOpen = false;
  lang: any = {};
  selectedLanguage: any ='';
  lang2: any = {};
  @Output() newItemEvent = new EventEmitter<string>();
  @Output() selectedlanguage = new EventEmitter();
  @Output() sidebarToggle = new EventEmitter<boolean>();
  logo = "https://testadminapi.groupbenefitz.aitestpro.com/api/ap/app/resources/images/broker/gb.jpg"

  changepasswordform: FormGroup = new FormGroup({
    oldpassword: new FormControl(''),
    newpassword: new FormControl(''),
    confirmpassword: new FormControl(''),
  });
  image:any;
  formConfiguration: any;
  parentlogo: any;
  PhzioMSK360: boolean=true;
  SolidGroundMethod: boolean=true;
  Alavida: boolean=true;
  NortonLifeLock: boolean=true;
  MyHsa: boolean=true;
  Equitqble:boolean=true;
  ENHCanada:boolean = true;
  CloudMD:boolean=true;
  RxFood:boolean=true;
  LifeSpeak:boolean=true;
  lifeSession:boolean=true;
  Carequest:boolean=true;
  newsLinkjan:any;
  newsLinkfed:any;
  newsLinkmar:any;
  showChevronDown: boolean=true;
  showChevronSettingsProfiles: boolean=true;
  showChevronDownForNews:boolean=true;
  historyLength: any;
  newLinks: any;
  link: any;
  showChevronDownhealth: boolean = true;
  showChevronDownwellness: boolean = true;
  showChevronDownbenefits: boolean = true;
  showChevronProfiles: boolean =true;
  headername: any;
  websitetitle: any;
  websitelink: any;
  greenshildcheck:any;
  equitablecheck:any;
  checknewpassword:boolean = false;
  customerid: any;
  clientName: any;
  accessToken: any;
  failedsignature: any;
  failedROE: any;
  filetype: any;
  waddelCustomer: any;
  selectedItemIndex: number | null = null;
  selectedItemIndex1:  number | null = null;
  profiles: any[] = []
  lang1: any;
  @Input() formConfig!: any;
  
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private sanitizer: DomSanitizer,
    private apiCommonService: ApiCommonService,
  ) {
    this.lang1=sessionStorage.getItem('language')?sessionStorage.getItem('language'):'English'
  }
  ngOnInit() {

    if(sessionStorage.getItem("language")==null||sessionStorage.getItem("language")==undefined){
      sessionStorage.setItem("language",'English')
      this.lang1='English'
    }
    this.getLanguageTokens()

    this.accessToken = sessionStorage.getItem('accessToken')
    let activeprofiles:any = sessionStorage.getItem('profiles')
    if (activeprofiles && activeprofiles.length > 0) {
       for (let pf of activeprofiles) {
        console.log(pf.token == this.accessToken, pf.token, this.accessToken)
        if (pf.token != this.accessToken) {
          this.profiles.push(pf)
        }
      }
    }
    setTimeout(() => {
      this.greenshildcheck = sessionStorage.getItem("GreenShild")
      this.equitablecheck = sessionStorage.getItem("Equitable")


    }, 5000);
    this.getFormConfiguration('en');
    this.image = sessionStorage.getItem("coproratelogo")



    if(this.image==""){
      this.image = '../../assets/img/group_befitzz.png';

    }else{
      this.image = sessionStorage.getItem("coproratelogo")


    }


    this.parentlogo = sessionStorage.getItem("parentlogo")
    let loginTime = sessionStorage.getItem('loginTime');
    this.changepasswordform = this.formBuilder.group(
      {
        oldpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]],
        newpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]],
        confirmpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]]},
      {
        validator: this.ConfirmedValidator('newpassword', 'confirmpassword'),
      }
    );

  }


  get changepass(): { [key: string]: AbstractControl } {
    return this.changepasswordform.controls;
  }

  public getLanguageTokens(){
    let body= {
      "project":"Member Portal",
      "url":"Header"
    }
    this.http
    .post(api.lang + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem('language')||'English'
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
        console.log(this.lang)
      }
    )
  }

  getFormConfiguration(lang: any) {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/formConfig';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formConfig'] && changes['formConfig'].currentValue) {
      this.formConfiguration = this.formConfig;
      this.newLinks=Object.keys(this.formConfiguration.news);
      this.newsLinkjan=this.formConfiguration.news['jan'];
      this.newsLinkfed=this.formConfiguration.news['feb'];
      this.newsLinkmar=this.formConfiguration.news['mar'];
      let tokens = this.formConfiguration.language_details.languageTokens;
      for(let token of tokens) {
        this.lang2[token.key] = token.value;
      }
    }
  }

  language(event: any) {
    this.selectedlanguage.emit(event.target.value);
    this.getFormConfiguration(event.target.value);
    sessionStorage.setItem("language",event.target.value)
    window.location.reload()
  }

  changepassword(){
    $("#changepassword").show()
    this.changepasswordform.reset()
    this.changepasswordform.get('oldpassword')?.reset();
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  checkpassword(){
    this.checknewpassword = false

  }
  getCustomerData(customer?:any) {
        const response = { data: customer }
        this.failedsignature = response.data.failedDocs
        this.waddelCustomer = response.data.serviceType.waddelCustomer

        this.failedROE = response.data.ROE
        this.filetype = this.failedROE


  }
  SubmitUpdatePassword(){
    var accessToken = sessionStorage.getItem('accessToken');
    let obj={
      "oldpassword":this.changepasswordform.value.oldpassword,
      "newpassword":this.changepasswordform.value.newpassword
    }
    var endPoint = "/user/changePassword";
    this.http
      .post(api.url + endPoint,obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }).subscribe((response: any) => {
      if(response["statusCode"] == 200 || response["status"] == 200){
        Swal.fire({title:'Success',text:response.message})
        sessionStorage.setItem("passwordchange","true")
        sessionStorage.setItem("loginTime", new Date().toISOString())

        this.changepasswordform.reset()
        window.location.reload()
        $("#updatepassword").hide()
        this.getCustomerData()
      }
      else if(response["statusCode"] == 400 || response["status"] == 400){
        Swal.fire({title:this.lang?.Error,text:response.message})
      }
      else{
        Swal.fire({title:this.lang?.Error,text:response.message})
      }
    }, (error) => {
      Swal.fire({title:this.lang?.Error,text:error.error.error.message})
    });
  }
  SubmitChangePassword(){

    if(this.changepasswordform.value.oldpassword==this.changepasswordform.value.newpassword){

      this.checknewpassword = true
    }
    else{
      this.checknewpassword = false
      var accessToken = sessionStorage.getItem('accessToken');
      let obj={
        "oldpassword":this.changepasswordform.value.oldpassword,
        "newpassword":this.changepasswordform.value.newpassword
      }
      var endPoint = "/user/changePassword";
      this.http
        .post(api.url + endPoint,obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }).subscribe((response: any) => {
        if(response["statusCode"] == 200 || response["status"] == 200){
          Swal.fire({title:'Success',text:response.message})
          sessionStorage.setItem("passwordchange","true")
          sessionStorage.setItem("loginTime", new Date().toISOString())

          this.changepasswordform.reset()
          $("#changepassword").hide()
        }
        else if(response["statusCode"] == 400 || response["status"] == 400){
          Swal.fire({title:this.lang?.Error,text:response.message})
        }
        else{
          Swal.fire({title:this.lang?.Error,text:response.message})
        }
      }, (error) => {
        Swal.fire({title:this.lang?.Error,text:error.error.error.message})
      });
    }

  }

  closeChangepassmodel(){
    $("#changepassword").hide()
    this.changepasswordform.reset()
    this.changepasswordform.get('oldpassword')?.reset();
  }

  logout() {
    let logoutWithUsername = JSON.parse(sessionStorage.getItem("logoutWithUsername") || "false")
    let currClient = sessionStorage.getItem("currClient")
    let username = sessionStorage.getItem("username")

    sessionStorage.clear();

    if(logoutWithUsername){
        if(username){
          if(currClient && currClient != 'null'){
            window.location.href = `/${currClient}/login?username=${username}`
          }else{
            window.location.href = `/login?username=${username}`
          }
        }else{
          if(currClient && currClient != 'null'){
            window.location.href = `/${currClient}/login`
          }else{
            window.location.href = '/login'
          }
        }
      }else{
        if(currClient && currClient != 'null'){
          window.location.href = `/${currClient}/login`
        }else{
          window.location.href = '/login'
        }
      }

    setTimeout(() => {
      this.apiCommonService.getIpAddress();
    }, 100);
  }


  downloads() {
    this.downloadCollapse = !this.downloadCollapse
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.sidebarToggle.emit(this.sidebarOpen);
  }

    toggleChevron() {
    this.showChevronDown = !this.showChevronDown;
    if(this.showChevronDown == true) {
      this.showChevronDownhealth = true;
      this.showChevronDownwellness = true;
      this.showChevronDownbenefits =  true;
    }
  }
  toggleChevron1() {
    this.showChevronDownForNews=!this.showChevronDownForNews;
  }
  toggleChevron2() {
    this.showChevronDownhealth=!this.showChevronDownhealth;
  }
  toggleChevron3() {
    this.showChevronDownwellness=!this.showChevronDownwellness;
  }
  toggleChevron4() {
    this.showChevronDownbenefits=!this.showChevronDownbenefits;
  }
  selectItem(index: number) {
    this.selectedItemIndex = index;
    this.selectedItemIndex1 =null
  }
  selectSubItem(index: number) {
    this.selectedItemIndex = index;
    this.selectedItemIndex1 =null
  }
  openwebsite(title: any,link: any) {

  }
  closewebsitemodal() {
    $('#website').hide();
  }
  newletters(month:any){
   this.link= this.formConfiguration.news[month];
   this.headername = month;
   $("#newletters2").show();
  }
  closeNewsletter() {
    $("#newletters2").hide();
  }


}
